module.exports = __webpack_public_path__ + "media/images/landing/persons/jakub-vysoky-f74ed8ee896688c140136e66429fb3e3.jpg";